import GlobalAPICall from '../../GlobalComponents/GlobalAPICall';
import { filter, switchMap } from 'rxjs/operators';

export default class SecurityQAndAProxy {
  constructor(authService) {
    this.authService = authService;
  }

  get() {
    return this.authService
      .getTokenObservable()
      .pipe(filter((token) => !!token))
      .pipe(
        switchMap((token) =>
          GlobalAPICall.getObservable(process.env.REACT_APP_AUTH_API_URL + `/api/SecurityQAndA`, {
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            },
          })
        )
      );
  }

  set(data) {
    return this.authService
      .getTokenObservable()
      .pipe(filter((token) => !!token))
      .pipe(
        switchMap((token) =>
          GlobalAPICall.postObservable(process.env.REACT_APP_AUTH_API_URL + `/api/MySecurityQuestionList/update`, data, {
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            },
          })
        )
      );
  }
}
